export class BaseError<T extends string> extends Error {
  name: T
  message: string

  constructor({ name, message }: { name: T; message?: string }) {
    super(message)
    this.name = name
    this.message = message || ''
  }
}
